import type { PriceAlertEventData } from "@/api/price-alerts";

export type TypeFilter = "all" | "spike" | "drop";

export const TYPE_OPTIONS: { value: TypeFilter; label: string }[] = [
  { value: "all", label: "All Alerts" },
  { value: "spike", label: "Spike ↑" },
  { value: "drop", label: "Drop ↓" },
];

export const TIMEFRAME_FILTERS: { value: string; label: string }[] = [
  { value: "all", label: "All" },
  ...["1m", "5m", "15m", "30m", "1h", "4h"].map((tf) => ({ value: tf, label: tf })),
];

/** Filters loaded events on the device; the events API has no type/timeframe filter. */
export function filterPriceAlertEvents(
  events: PriceAlertEventData[],
  type: TypeFilter,
  timeframe: string
): PriceAlertEventData[] {
  return events.filter(
    (event) =>
      (type === "all" || event.alertType.toLowerCase() === type) &&
      (timeframe === "all" || event.interval === timeframe)
  );
}
